import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Settings, AppSettings } from '../../components/shared/services/color-option.service';

@Component({
    selector: 'app-color-options',
    templateUrl: './color-options.component.html',
    styleUrls: ['./color-options.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColorOptionsComponent {
  public showOptions:boolean = false;
  public activeItem: string;
  public layoutsidebar: boolean = false;
  public settings: Settings;
  public dark: boolean;

  public show:boolean = false;
  public buttonName:any = 'Dark';
  constructor(public appSettings:AppSettings) { 
    this.settings = this.appSettings.settings; 
  }

  public changeTheme(theme){
    this.settings.theme = theme;       
  } 
 
    isActive(menuItem) {
      return this.activeItem === menuItem
    }



   customizeThemeColor(event) {
    document.documentElement.style.setProperty('--theme-deafult', event.target.value);
  }

    layoutSidebarToggle() {
      this.layoutsidebar = !this.layoutsidebar
    }

    customizeLayoutDark() {
      document.body.classList.toggle('dark')

      this.show = !this.show;


    if(this.show)  
      this.buttonName = "Light";
    else
      this.buttonName = "Dark";
  }
    }
